import { useQuery } from "@tanstack/react-query";
import { getValueItemById } from "../../api/apiValueItems";

export function useGetValueItem(id) {
    const { isLoading, data, error, refetch } = useQuery({
        queryKey: ["value-item", id],
        queryFn: () => getValueItemById(id),
        enabled: !!id,
        retry: false,
    });

    const item = data?.data || null;

    return { isLoading, error, item, refetch };
}
